<div class="form">
  <div class="form__title" [innerHTML]="data?.text"></div>
  @if (!data?.oneAction) {
    <div class="submit-container">
      <button class="btn small" (click)="modal.close()">{{'btn.cancel' | translate}}</button>
      <button class="btn small" (click)="modal.close(true)">{{'t.apply' | translate}}</button>
    </div>
  }
  @if (data?.oneAction) {
    <div class="submit-container one-action">
      <button class="btn small" (click)="modal.close()">{{'btn.ok' | translate}}</button>
    </div>
  }
</div>
